import { useEffect, useState, useRef } from 'react';
import classnames from 'classnames';

import { BodySmallText } from '../typography/typography';
import { CounterStyle } from './counter-style';

export interface ICounter {
  label: string;
  dataCy: string;
  maxCount: number;
  minCount?: number;
  value?: number;
  onChange?: (...event: any[]) => void;
  inputRef?: React.Ref<any>;
}

const Counter: React.FC<ICounter> = ({ label, value, dataCy, maxCount, minCount, inputRef, onChange }) => {
  const minCountState = minCount === undefined || minCount === null ? 1 : minCount;
  const [number, setNumber] = useState<number>(value && value > 0 ? value : (minCount ?? 0));

  const shouldUpdate = useRef<boolean>(false);

  const handleNumberChange = (typeOfChange: 'increase' | 'decrease') => {
    if (typeOfChange === 'increase' && number < maxCount) {
      setNumber(number + 1);
    } else if (typeOfChange === 'decrease' && number > minCountState) {
      setNumber(number - 1);
    }
    shouldUpdate.current = true;
  };

  useEffect(() => {
    if (onChange && shouldUpdate.current) {
      onChange(number);
      shouldUpdate.current = false;
    }
  }, [number, onChange]);

  return (
    <CounterStyle data-cy={dataCy} ref={inputRef} tabIndex={0}>
      <div className="counter-label">
        <BodySmallText weight={600}>{label}</BodySmallText>
      </div>
      <div className="counter-form">
        <div
          data-cy="decreaseCounter"
          className={classnames('counter-form-button', {
            disabled: number === minCountState,
          })}
          onClick={() => handleNumberChange('decrease')}
        >
          -
        </div>
        <div className="counter-form__number">{number}</div>
        <div
          data-cy="increaseCounter"
          className={classnames('counter-form-button', {
            disabled: maxCount === number,
          })}
          onClick={() => handleNumberChange('increase')}
        >
          +
        </div>
      </div>
    </CounterStyle>
  );
};

export default Counter;
